export function defaultTone() {
  return {
  type: 'linear' as 'linear' | 'asinh',
  linear: {
    contrast: 1,
    bias: 0.25,
  },
  asinh: {
    beta: 10,
    b0: 0,
    a: 0.5,
    bias: 0.25,
  },
  }
}

export type Tone = ReturnType<typeof defaultTone>
